import { calculatePrescription } from './calculate-prescription.js';
import { getAvailability } from './get-availability.js';
import { validateConfigurator } from './validate-configurator.js';

/**
 * Calls the different helper functions in order to retrieve the complete state
 * needed for the Lenses component
 */ const getPrescriptionState = (config, isPrescriptionInfoEnabled, variant, cartDiscounts)=>{
    const { availability , selectedVariantsData  } = getAvailability(config);
    const formErrorState = validateConfigurator(config, isPrescriptionInfoEnabled);
    const { isPrescriptionInfoValid , isConfiguratorValid  } = formErrorState;
    const prescriptionResult = calculatePrescription(config, isPrescriptionInfoEnabled, variant, isPrescriptionInfoValid && isConfiguratorValid, cartDiscounts);
    return {
        availability,
        formErrorState,
        prescriptionResult,
        selectedVariantsData
    };
};

export { getPrescriptionState };
//# sourceMappingURL=get-prescription-state.js.map
